var $0e55c776c1bcfcb6$exports = {};
$0e55c776c1bcfcb6$exports = {
    "removeButtonLabel": `Kald\u{131}r`,
    "removeDescription": `Etiketi kald\u{131}rmak i\xe7in Sil tu\u{15F}una bas\u{131}n.`
};


export {$0e55c776c1bcfcb6$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
